const formatDateFilters = (inputDate: Date | null): string | null => {
  // Extract the year, month, and day, ensuring month and day are in two-digit format
  if (!inputDate) {
    return null
  }
  const year = inputDate.getFullYear()
  const month = ('0' + (inputDate.getMonth() + 1)).slice(-2) // Add 1 because months are 0-indexed, then pad with leading zero
  const day = ('0' + inputDate.getDate()).slice(-2) // Pad with leading zero

  // Format the date in "YYYY-MM-DD" format
  const formattedDate = `${year}-${month}-${day}`

  return formattedDate // Return the formatted date string
}

export default formatDateFilters
